import { ImageWithFallback } from '~/components/ImageWithFallback'
import { CommandMenuView } from '~/components/command-menu/components/CommandMenuView'
import { useCommandMenu } from '~/components/command-menu/hooks/useCommandMenu'
import { CommandMenuViewType } from '~/components/command-menu/types'
import { useActiveOrg } from '~/hooks/org/useActiveOrg'
import { useSetActiveOrg } from '~/hooks/org/useSetActiveOrg'
import { useAuthUser } from '~/hooks/useAuthUser'

export const SelectWorkspace = ({ view }: { view: CommandMenuViewType }) => {
  const { getViewOptions, getViewCallback } = useCommandMenu()
  const { user } = useAuthUser()
  const { setActiveOrg } = useSetActiveOrg()
  const { org } = useActiveOrg()
  const viewOptions = getViewOptions()

  return (
    <CommandMenuView
      items={
        user?.orgs
          .filter((o) => o.id !== org?.id)
          .map((org) => ({
            label: () => org.name,
            icon: () => (
              <ImageWithFallback
                src={org.logoUrl}
                fallbackSrc="/logo_light.svg"
                alt={`${org.name} logo`}
                width={16}
                height={16}
                className="rounded-md object-cover"
              />
            ),
            value: () => `${org.name} - ${org.id}`,
            onSelect: ({ actions: { setActiveView } }) => {
              const callback = getViewCallback()

              if (callback) {
                callback(org)
              } else {
                setActiveOrg(org, '/')
                setActiveView(null)
              }
            },
            shortcuts: [],
          })) || []
      }
      placeholder={
        viewOptions?.placeholder || 'Select a workspace to switch to...'
      }
      view={view}
      primaryActionLabel={viewOptions?.primaryActionLabel ?? 'Open'}
    />
  )
}
